export default "__VITE_ASSET__Lm2wJzr6__"